import { styled } from '@mui/material';

const StyledNotFound = styled('div')`
  padding: 25px 0;
  .create-page-container {
    padding-left: 75px;
    padding-right: 75px;
  }

  .content {
    position: relative;
    padding: 2rem;
    margin-bottom: 2rem;
    border-radius: 10px;
    background-color: #fff;
  }

  .content__title {
    font-size: ${props => props.theme.customTheme.sizes.xLarge};
    font-style: normal;
    font-weight: 600;
    line-height: 1.5;
    margin-top: 0;
    margin-bottom: 1.25rem;
    text-align: center;
  }

  .imgs {
    display: flex;
    justify-content: center;
    img {
    }
  }

  .back-stage-btn {
    position: absolute;
    left: 0;
    top: 0;
    transform: translateX(-150%);

    width: 38px;
    height: 38px;
    border-radius: 10px;
    background-color: transparent;
    justify-content: center;
    svg {
      color: ${props => props.theme.customTheme.colors.dark};
      width: 24px;
      height: 24px;
    }
  }

  .btns {
    width: 100%;
    display: flex;
    justify-content: end;
    .homepage-button {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }

  @media (max-width: 768px) {
    .create-page-container {
      padding-left: 25px;
      padding-right: 25px;
    }
    .content__title {
      font-size: ${props => props.theme.customTheme.sizes[16]};
    }

    .imgs {
      display: flex;
      justify-content: center;
      img {
        width: 100%;
      }
    }

    .btns {
      width: 100%;
      display: flex;
      justify-content: center;
      .homepage-button {
        display: flex;
        align-items: center;
        justify-content: center;
        span{
            font-size: 12px !important;

            svg {
              width: 8px;
              height: 8px;
            }
        }
      }
    }
  }
`;

export default StyledNotFound;
